import { Stepper } from '../ui/Stepper';
import { useBufferedCommit } from '../../hooks/useBufferedCommit';
import type { CustomerFileControl } from './useCustomerFile';

/** Zoveel stuks van één product per levering; meer is een bestelling, geen abonnement. */
const MAX_QTY_PER_DELIVERY = 9;
type Props = {
  ctl: CustomerFileControl;
  productId: string;
  qty: number;
  label: string;
};

/**
 * Aantal van één product in het abonnement. Elke tik telt meteen op het scherm; pas na een
 * korte rust gaat de eindstand als één wijziging naar de server. Loopt er nog een andere
 * abonnementsactie, dan wacht hij daarop, zodat de server de acties in volgorde krijgt.
 * Mislukt het, dan zet het dossier het oude aantal terug (zie useCustomerFile).
 */
export function SubscriptionQty({
  ctl,
  productId,
  qty,
  label
}: Props) {
  const [value, setValue] = useBufferedCommit(qty, next => ctl.subscription({
    type: 'setQty',
    productId,
    qty: next
  }), {
    canCommit: () => !ctl.isBusy('subscription')
  });
  return <Stepper value={value} min={1} max={MAX_QTY_PER_DELIVERY} onChange={setValue} label={label} data-id="element-1541" data-mp="3p1cq6xi7zjn" />;
}